import React, { Component, Fragment } from 'react';
import { Row, Col, Spin, Menu } from 'antd';
import { inject, observer } from 'mobx-react/index';
import { Link, Route, Switch } from 'react-router-dom';
import { IndicatorTabs } from './IndicatorTabs';
const MenuItemGroup = Menu.ItemGroup;
// import {IndicatorSpy} from "./IndicatorSpy";
// import {GeneralSection} from "../SettingsView/GeneralSection";

@inject('store')
@observer
export class IndicatorsView extends Component {
    constructor(props) {
        super(props);

        this.state = {
            selected: null,
            filter: ''
        };
    }

    renderGroup(mode, name) {
        const strats = this.props.store.botStore.indicatorStore.indicators;

        if (!Object.keys(strats || {}).length) return null;

        const specificStrats = Object.keys(strats)
            .map(stratId => {
                const strat = strats[stratId];
                if (strat.type !== mode) return null;
                return (
                    <Menu.Item key={stratId}>
                        <Link to={`${this.props.match.url}/${stratId}`}>{strat.name}</Link>
                    </Menu.Item>
                );
            })
            .filter(a => a != null);

        if (!specificStrats.length) return null;

        return (
            <MenuItemGroup key={mode} title={name}>
                {specificStrats}
            </MenuItemGroup>
        );
    }

    render() {
        const strats = this.props.store.botStore.indicatorStore.indicators;
        const config = this.props.store.botStore.currentConfiguration;
        if (!strats)
            return (
                <div style={{ padding: 50, textAlign: 'center' }}>
                    <Spin
                        tip={
                            <span>
                                No Strategies Running
                                <br /> {config.selected_symbols.length} Coins Selected
                            </span>
                        }
                        size="large"
                    />
                </div>
            );
        if (!Object.keys(strats).length)
            return (
                <div style={{ padding: 50, textAlign: 'center' }}>
                    <Spin tip="Loading" size="large" />
                </div>
            );

        return (
            <Fragment>
                <Row gutter={24}>
                    <Col md={5}>
                        <Menu mode="inline">
                            {this.renderGroup('buy_sell', 'Buy/Sell')}
                            {this.renderGroup('trigger', 'Trigger')}
                            {this.renderGroup('adca', 'Auto DCA')}
                            {this.renderGroup('art', 'Auto RT')}
                        </Menu>
                    </Col>

                    <Switch>
                        <Route path="/a/bot/:botId/indicators/:id" component={IndicatorTabs} />
                    </Switch>
                </Row>
            </Fragment>
        );
    }
}



// WEBPACK FOOTER //
// ./src/Account/Bot/IndicatorsView/index.js